export default "__VITE_ASSET__BFIqf9W5__"